module.exports = __webpack_public_path__ + "img/home.a7d1a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home.png
// module id = P7rK
// module chunks = 3